/* V-Belt Guys belt rules for the belt games.
   Mirrors the vbg-belt-decoder rules (checked against decode_belt.py on 2026-10-23):
   classical A/B/C: number = inside length, outside = number + 2 / 3 / 4
   FHP 3L/4L/5L and wedge 3V/5V: number = outside length in tenths of an inch
   X = cogged (notched). Banded = ribs/section + base number. */
(function (g) {
  var SEC = {
    A:  { w: 0.5,   fam: 'V', add: 2, kind: 'classic' },
    B:  { w: 0.656, fam: 'V', add: 3, kind: 'classic' },
    C:  { w: 0.875, fam: 'V', add: 4, kind: 'classic' },
    '3L': { w: 0.375, fam: 'V', tenths: true, kind: 'fhp' },
    '4L': { w: 0.5,   fam: 'V', tenths: true, kind: 'fhp' },
    '5L': { w: 0.656, fam: 'V', tenths: true, kind: 'fhp' },
    '3V': { w: 0.375, fam: 'W', tenths: true, kind: 'wedge' },
    '5V': { w: 0.625, fam: 'W', tenths: true, kind: 'wedge' }
  };
  var FRAC = { 0.375: '3/8', 0.5: '1/2', 0.625: '5/8', 0.656: '21/32', 0.875: '7/8' };

  function make(sec, num, cog, ribs) {
    var s = SEC[sec]; if (!s) return null;
    var oc = s.tenths ? num / 10 : num + s.add;
    var pn = (ribs ? ribs + '/' : '') + sec + (cog ? 'X' : '') + num;
    if (s.kind === 'classic' && cog && !ribs) pn = sec + 'X' + num;
    return { pn: pn, sec: sec, num: num, cog: !!cog, ribs: ribs || 0, w: s.w, fam: s.fam,
             kind: s.kind, oc: oc, frac: FRAC[s.w] };
  }
  function parse(pn) {
    var m = /^(?:(\d)\/)?(3L|4L|5L|3V|5V|A|B|C)(X?)(\d+)$/.exec(pn);
    return m ? make(m[2], +m[4], m[3] === 'X', m[1] ? +m[1] : 0) : null;
  }
  // Same belt = same family shape, width, outside length, notching and rib count.
  function same(a, b) {
    return a && b && a.fam === b.fam && a.w === b.w && a.oc === b.oc && a.cog === b.cog && a.ribs === b.ribs;
  }
  // The other notation for the same belt (A90 <-> 4L920, B89 <-> 5L920), or null.
  function twin(b) {
    if (b.ribs || b.cog) return null;
    if (b.sec === 'A') return make('4L', (b.oc) * 10);
    if (b.sec === 'B') return make('5L', (b.oc) * 10);
    if (b.sec === '4L' && Number.isInteger(b.oc - 2)) return make('A', b.oc - 2);
    if (b.sec === '5L' && Number.isInteger(b.oc - 3)) return make('B', b.oc - 3);
    return null;
  }
  function rint(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }

  // A random real-looking belt for a given difficulty tier.
  function random(tier) {
    var opts = ['A', 'B', 'C'];
    if (tier >= 2) opts = opts.concat(['4L', '5L', '3L']);
    if (tier >= 3) opts = opts.concat(['3V', '5V']);
    var sec = pick(opts), s = SEC[sec], cog = false, ribs = 0;
    if (tier >= 3 && sec !== '3L' && sec !== '4L' && sec !== '5L' && Math.random() < 0.35) cog = true;
    if (tier >= 4 && (sec === 'A' || sec === 'B' || sec === '3V' || sec === '5V') && Math.random() < 0.4) { ribs = rint(2, 4); cog = false; }
    var num;
    if (s.kind === 'classic') num = sec === 'C' ? rint(15, 32) * 4 : rint(15, 64) * 2;
    else if (s.kind === 'fhp') num = rint(25, 120) * 10;
    else num = rint(25, 140) * 10;
    return make(sec, num, cog, ribs);
  }
  g.VBGBelts = { SEC: SEC, FRAC: FRAC, make: make, parse: parse, same: same, twin: twin, random: random, rint: rint, pick: pick };
})(window);
